import { Dayjs } from "dayjs";
import { FC, ComponentType, ReactNode } from "react";
import { Input } from "antd";
import AppDateCalendar from "@Components/AppDateCalendar/AppDateCalendar";
import { withFloatingLabel } from "src/HOC";
import { formatDate } from "src/utility/time";

const FloatingInput = withFloatingLabel(Input);
const DATE_FORMAT = "ddd, DD MMM YYYY";

type TripDateSelectMobProps = {
  value?: string | Dayjs;
  onChange?: (value: Dayjs) => void;
  label?: ReactNode;
  icon?: ComponentType<{ className?: string }>;
  disabledDate?: (date: Dayjs) => boolean;
  closeSheet?: () => void;
  validationError?: string[];
};

const TripDateSelectMob: FC<TripDateSelectMobProps> = ({
  value,
  onChange,
  label,
  icon: Icon,
  disabledDate,
  closeSheet,
  validationError = [],
}) => {
  const hasValidationErrors = validationError.length >= 1;

  return (
    <div className="flex h-full flex-col gap-2 p-4">
      <div className="gap-2! outline-border-default focus-within:outline-border-active py-2! flex shrink-0 items-center justify-center rounded-md px-4 outline">
        {Icon && (
          <div>
            <Icon className="h-5 w-5 text-current" />
          </div>
        )}
        <FloatingInput
          label={label}
          readOnly
          value={formatDate(value, DATE_FORMAT)}
          variant="borderless"
          className="pt-6! pb-2! px-3! font-semibold"
        />
      </div>
      {hasValidationErrors && <div className="text-font-danger flex items-center justify-start px-3">{validationError?.[0]}</div>}

      <AppDateCalendar value={value} onChange={onChange} onSelected={closeSheet} disablePast shouldDisableDate={disabledDate} autoFocus />
    </div>
  );
};

export default TripDateSelectMob;
